import { useI18n } from '@/hooks/useI18n';
import { useDocumentLang } from '@/hooks/useDocumentLang';

export const PrivacyPage = () => {
  const { t } = useI18n();
  useDocumentLang();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            {t('privacy.title')}
          </h1>

          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 mb-6">
              {t('privacy.lastUpdated')}: {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('privacy.intro.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacy.intro.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('privacy.dataCollection.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacy.dataCollection.intro')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>{t('privacy.dataCollection.item1')}</li>
                <li>{t('privacy.dataCollection.item2')}</li>
                <li>{t('privacy.dataCollection.item3')}</li>
                <li>{t('privacy.dataCollection.item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('privacy.dataUsage.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacy.dataUsage.intro')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>{t('privacy.dataUsage.item1')}</li>
                <li>{t('privacy.dataUsage.item2')}</li>
                <li>{t('privacy.dataUsage.item3')}</li>
                <li>{t('privacy.dataUsage.item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('privacy.dataSecurity.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacy.dataSecurity.content')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('privacy.userRights.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacy.userRights.intro')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>{t('privacy.userRights.item1')}</li>
                <li>{t('privacy.userRights.item2')}</li>
                <li>{t('privacy.userRights.item3')}</li>
                <li>{t('privacy.userRights.item4')}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t('privacy.contact.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacy.contact.content')}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
